<template>
    <q-table
        ref="table"
        :data="data"
        :columns="columns"
        row-key="id"
        :pagination.sync="server_pagination"
        @request="request"
        :loading="loading"
        :no-data-label="$t('no_data_avaliable')"
        :no-results-label="$t('no_results_found')"
        :loading-label="$t('loading_data')"
        :rows-per-page-label="$t('items_per_page')"
        :rows-per-page-options="[5,10,50,100]"
        binary-state-sort
        class="q-mt-lg"
        >

        <q-tr slot="header" slot-scope="props" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
            {{ $t(col.label) }}
            </q-th>
        </q-tr>

        <template slot="body" slot-scope="props">
            <q-tr :props="props">
                <q-td key="webcast_title" :props="props">
                    {{ props.row.webcast_title }}
                </q-td>

                <q-td key="webcast_test_title" :props="props">
                    {{ props.row.webcast_test_title }}
                </q-td>

                <q-td key="webcast_test_type_id" :props="props">
                    {{ $t(getTestType(props.row.webcast_test_type_id)) }}
                </q-td>

                <q-td key="qty_questions" :props="props">
                    {{ props.row.qty_questions }}
                </q-td>

                <q-td key="score" :props="props">
                    {{ props.row.score ? props.row.score.toFixed(2) : '' }}
                </q-td>

                <q-td key="percent" :props="props">
                    {{ props.row.percent ? `${props.row.percent.toFixed(2)}%` : '' }}
                </q-td>

                <q-td key="test_score" :props="props">
                    {{ props.row.test_score ? props.row.test_score.toFixed(2) : '' }}
                </q-td>

                <q-td key="result_date" :props="props">
                    {{ getDateFormated(props.row.result_date) }}
                </q-td>

                <q-td key="status" :props="props">
                    <q-chip small :icon="getIconStatus(props.row.status)"  :color="getColorStatus(props.row.status)" class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>
            </q-tr>
        </template>
    </q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    data() {
        return {
            loading: false,
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns: [
                {
                    name: 'webcast_title',
                    required: true,
                    label: 'webcast',
                    align: 'left',
                    field: 'webcast_title',
                    sortable: false,
                },
                {
                    name: 'webcast_test_title',
                    required: true,
                    label: 'test_title',
                    align: 'left',
                    field: 'webcast_test_title',
                    sortable: false,
                },
                {
                    name: 'webcast_test_type_id',
                    required: true,
                    label: 'type',
                    align: 'left',
                    field: 'webcast_test_type_id',
                    sortable: false,
                },
                {
                    name: 'qty_questions',
                    required: true,
                    label: 'questions',
                    align: 'left',
                    field: 'qty_questions',
                    sortable: false,
                },
                {
                    name: 'score',
                    required: true,
                    label: 'hits',
                    align: 'left',
                    field: 'score',
                    sortable: false,
                },
                {
                    name: 'percent',
                    required: true,
                    label: 'percent',
                    align: 'left',
                    field: 'percent',
                    sortable: false,
                },
                {
                    name: 'test_score',
                    required: true,
                    label: 'test_score',
                    align: 'left',
                    field: 'test_score',
                    sortable: false,
                },
                {
                    name: 'result_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'result_date',
                    sortable: false,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                },
            ],
            data: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            selected_user: 'users/selected_user',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        request({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_users/users/${this.selected_user}/get_user_webcasts_tests_user_results/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.data = []

                response.data.results.forEach(result => {
                    this.data.push(result)
                })
            })
            .catch(e => {

                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        getTestType(type) {
            if (type == 1) {
                return 'conventional_test'
            }
            else if (type == 2) {
                return 'block_test'
            }
            else if (type == 3) {
                return 'restart_test'
            }
            else if (type == 4) {
                return 'unevaluated_quiz'
            }
            else if (type == 5) {
                return 'evaluated_quiz'
            }
        },

        getDateFormated(d) {
            return date.formatDate(d, 'DD/MM/YYYY HH:mm:ss')
        },

        getStatus(status) {
			switch(status) {
                case 1: return 'aproved'
                break
                case 2: return 'reproved'
                break
                case 3: return 'blocked'
                break
                case 4: return 'restarted_training'
                break
                case 5: return 'improved_score'
                break
            }
		},

        getColorStatus(status) {
             switch(status) {
                case 1:
                case 5: return 'positive'
                break
                case 2:
                case 3: return 'negative'
                break
                case 4: return 'warning'
                break
            }
		},
		getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-ban'
            else if (status == 4) return 'fas fa-sync'
            else if (status == 5) return 'fas fa-star-half-alt'
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        }
    },

    watch: {
        num_rows: {
            handler (newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()

        this.request({ pagination: this.server_pagination })
    }
}
</script>

<style>

</style>